import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { forwardRef } from 'react';
import { ButtonProps } from '../button';
import { IconButton } from '../icon-button';

interface FavoriteProps extends ButtonProps {
  active: boolean;
  onToggle: (value: boolean) => void;
}

// eslint-disable-next-line react/display-name
const Favorite = forwardRef<HTMLButtonElement, FavoriteProps>((props, ref) => {
  const { onToggle, ...rest } = props;
  const isActive = props.active;

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onToggle?.(!isActive);
  };

  const Icon = isActive ? HeartFilled : HeartOutlined;

  return (
    <IconButton
      ref={ref}
      {...rest}
      icon={Icon}
      variant="primaryInverse"
      onClick={(e) => handleClick(e)}
      style={{ flexShrink: 0 }}
    />
  );
});

export { Favorite };
